import React from 'react';

type ConsentStatus = 'granted' | 'denied' | null;

interface ConsentBannerProps {
  onChange: (status: Exclude<ConsentStatus, null>) => void;
}

const STORAGE_KEY = 'consent_status_v1';

export function getStoredConsent(): ConsentStatus {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw === 'granted' || raw === 'denied') return raw;
  return null;
}

export function setStoredConsent(status: Exclude<ConsentStatus, null>) {
  localStorage.setItem(STORAGE_KEY, status);
}

const ConsentBanner: React.FC<ConsentBannerProps> = ({ onChange }) => {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const current = getStoredConsent();
    setVisible(current === null);
  }, []);

  const handleGrant = () => {
    setStoredConsent('granted');
    setVisible(false);
    onChange('granted');
  };

  const handleDeny = () => {
    setStoredConsent('denied');
    setVisible(false);
    onChange('denied');
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">
        <div className="bg-white border border-gray-200 shadow-lg rounded-xl p-4 md:p-5">
          <div className="flex items-start gap-3">
            <div className="flex-1 text-sm text-gray-700">
              本サイトでは、利用状況の把握や機能改善のためにアクセス解析や広告（Cookie等を利用）を行います。よろしければ「同意する」を押してください。設定はブラウザのストレージに保存されます。
            </div>
            <div className="flex-shrink-0 flex gap-2">
              <button className="btn-secondary" onClick={handleDeny}>同意しない</button>
              <button className="btn-primary" onClick={handleGrant}>同意する</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;


